module.exports = __webpack_public_path__ + "img/广告-5 - 一代枭雄.bd6ad458.jpg";